const atgUserManagementContent = {
  list: {
    addAccount: 'Add Account',
    selectedAccounts: 'Selected Accounts',
    accountGroup: 'Account Group',
    accountNumber: 'Account #',
    authorizedDivisions: 'Authorized Division(s)',
    accountName: 'Account Name',
    city: 'City',
    state: 'State/Province',
    zipCode: 'ZIP code/Postal Code',
    deleteAccounts: 'Delete Account(s)',
    deleteCount: 'Delete {{count}} Account',
    emptyState: 'No accounts selected. Click "Add Account" to select accounts.',
    searchForAccounts: 'Search For Accounts',
    searchCriteriaHint: '(Division, Account Type, and one additional criteria required)',
    atgDivision: 'ATG Division',
    selectDivision: 'Select Division',
    accountType: 'Account Type',
    selectAccountType: 'Select Account Type',
    divisionRequired: 'Division is required.',
    accountTypeRequired: 'Account Type is required.',
    country: 'Country',
    selectCountry: 'Select Country',
    selectState: 'Select State/Province',
    search: 'Search',
    reset: 'Reset',
    resultsTitle: 'Results Matching Your Criteria:',
    selectAccountDivision: 'Select Account Division',
    selectAll: 'Select All',
    selectedCount: '{{count}} selected',
    clearAll: 'Clear All',
    noResults: 'No results found.',
    close: 'Close',
    linkedAccounts: 'Linked Accounts',
  },
  addUser: {
    title: 'Add User',
    subtitle: 'Fill in the details below to create a new user account.',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'E-Mail',
    businessPhone: 'Business Phone',
    address: 'Address',
    city: 'City',
    country: 'Country',
    state: 'State/Province',
    active: 'Active',
    activeStatus: 'Active Status',
    userRole: 'User Role',
    language: 'Language',
    zipCode: 'ZIP code/Postal Code',
    selectCountry: 'Select Country',
    selectState: 'Select State/Province',
    selectActiveStatus: 'Select Active Status',
    selectUserRole: 'Select User Role',
    firstNameRequired: 'First Name is required.',
    lastNameRequired: 'Last Name is required.',
    emailRequired: 'Email is required.',
    emailInvalid: 'Please enter a valid email address.',
    businessPhoneRequired: 'Business Phone is required.',
    businessPhonePattern: 'Business Phone must contain numbers only.',
    businessPhoneMinLength: 'Business Phone must be at least 7 digits.',
    businessPhoneMaxlength: 'Business Phone must not exceed 10 digits.',
    addressRequired: 'Address is required.',
    cityRequired: 'City is required.',
    countryRequired: 'Country is required.',
    stateRequired: 'State is required.',
    activeRequired: 'Active Status is required.',
    userRoleRequired: 'User Role is required.',
    languageRequired: 'Language is required.',
    zipCodeRequired: 'ZIP Code/Postal Code is required.',
    accountSelectionRequired: 'Please associate at least one account to Proceed',
    createSuccess: 'User created successfully',
    createFailed: 'Failed to create user. Please try again.',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    accountStatus: 'Account Status',
  },
  editUser: {
    userDetails: 'User Details',
    accountStatus: 'Account Status',
    customerName: 'Account Name',
    email: 'E-Mail',
    accountActivatedDate: 'Account Activated Date',
    activatedBy: 'Activated By',
    userRole: 'User Role',
    dateFormat: 'Date Format',
    phoneNumber: 'Phone Number',
    phoneNumberPattern: 'Please enter numbers only.',
    phoneNumberMinLength: 'Phone number must be at least 7 digits.',
    phoneNumberMaxlength: 'Phone number must not exceed 10 digits.',
    salesDistrict: 'Sales District',
    salesGroup: 'Sales Group',
    salesOffice: 'Sales Office',
    group: 'Group',
    language: 'Language',
    selectLanguage: 'Select Language',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    city: 'City',
    country: 'Country',
    selectCountry: 'Select Country',
    state: 'State/Province',
    selectState: 'Select State/Province',
    zipCode: 'ZIP code/Postal Code',
    postalCode: 'ZIP code/Postal Code',
    userCreatedOn: 'User Created On',
    lastLoginDate: 'Last Login Date',
    emailSentDate: 'E-Mail Sent Date',
    emailSentBy: 'E-Mail Sent By',
    createOrder: 'Create Order',
    reviewAccounts: 'Review Accounts',
    save: 'Save',
    saving: 'Saving...',
    cancel: 'Cancel',
    resetPassword: 'Reset Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    enterOldPassword: 'Enter old password',
    enterNewPassword: 'Enter new password',
    confirmNewPasswordPlaceholder: 'Confirm new password',
    submit: 'Submit',
    submitting: 'Submitting...',
    accountSelectionRequired: 'Please associate at least one account to Proceed',
    requestAccountAccess: 'Request Account Access',
    requestAccessSuccess: 'Account access request submitted successfully',
    passwordUpdateSuccess: 'Password updated with success',
  },
};

export const atgUserManagement = {
  ...atgUserManagementContent,
  atgUserManagement: atgUserManagementContent,
};
